import { SignInData } from './types';

export const inputId: SignInData = {
  number: 'number',
  password: 'password',
};
